import { useEffect, useState } from "react";
import { adminApi, apiError } from "@/admin/api";
import { fullUrl } from "@/lib/api";
import { toast } from "sonner";
import { UploadCloud, Trash2, Copy, Loader2 } from "lucide-react";

export default function Media() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = () => adminApi.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      await adminApi.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Uploaded"); load();
    } catch (err) { toast.error(apiError(err)); } finally { setUploading(false); e.target.value = ""; }
  };

  const del = async (id) => { await adminApi.delete(`/admin/media/${id}`); toast.success("Deleted"); load(); };
  const copy = (url) => { navigator.clipboard.writeText(fullUrl(url)); toast.success("URL copied"); };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Media Library</h1>
        <label className="inline-flex items-center gap-2 rounded-lg bg-[hsl(13_65%_54%)] text-white px-4 py-2 text-sm font-medium cursor-pointer" data-testid="media-upload">
          {uploading ? <Loader2 size={15} className="animate-spin" /> : <UploadCloud size={15} />} Upload
          <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={upload} />
        </label>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="media-grid">
        {items.map((m) => (
          <div key={m.id} className="bg-white rounded-xl border border-gray-200 overflow-hidden group">
            <img src={fullUrl(m.url)} alt={m.name} className="h-32 w-full object-cover" />
            <div className="p-2">
              <p className="text-xs text-gray-600 truncate">{m.name}</p>
              <div className="flex gap-2 mt-2">
                <button onClick={() => copy(m.url)} className="flex-1 text-xs rounded border border-gray-300 py-1 inline-flex items-center justify-center gap-1"><Copy size={12} /> URL</button>
                <button onClick={() => del(m.id)} className="text-xs rounded border border-gray-300 px-2 text-red-600"><Trash2 size={12} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-sm text-gray-400 col-span-full">No media yet. Upload images to use across your site content.</p>}
      </div>
    </div>
  );
}
